import React from "react";
import "./App.css";
import { BrowserRouter as Router } from "react-router-dom";
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import store, { persistor } from './redux/store/store';
import AuthenticatesRoutes from "./routes/Routes";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import useSessionTimeout from './utils/useSessionTimeout';
import CheckConnection from "./utils/CheckConnection";

// Create a wrapper component to use the hook inside Provider
const AppContent = () => {
  useSessionTimeout(); // This will handle auto-logout
  return <AuthenticatesRoutes />;
};

function App() {
  if (true) {
    console.log = () => {};
    console.warn = () => {};
    console.error = () => {};
    console.info = () => {};
    console.debug = () => {};
    for (let method of ["log", "warn", "error", "info", "debug"]) {
      console[method] = () => {};
    }
  }
  
  const originalError = console.error;
  console.error = function (...args) {
    if (args[0]?.includes("Failed to load resource")) {
      return; // ignore this error
    }
    originalError.apply(console, args); // show others
  };
  return (
    <Provider store={store}>
      {/* <CheckConnection> */}
      <PersistGate loading={null} persistor={persistor}>
        <Router>
        <ToastContainer 
            position="top-right"
            autoClose={5000}
            hideProgressBar={false}
            newestOnTop={false}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
            limit={3}
            theme="light"
            enableMultiContainer={false}
          />
          <AppContent />
        </Router>
      </PersistGate>
     
      {/* </CheckConnection> */}
    </Provider>
  );
}

export default App;
